import React, { useEffect, useState } from "react";
import axios from "axios";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import { Card, CardContent } from "./card";
import { Dialog } from "@headlessui/react";
import { X } from "lucide-react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const estadoColors = {
  Programado: "#3b82f6",
  Pendiente: "#f59e0b",
  Completado: "#22c55e",
  Cancelado: "#ef4444",
};

export default function CronogramaCalendar() {
  const [eventos, setEventos] = useState([]);
  const [eventoActivo, setEventoActivo] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  // eslint-disable-next-line
  const [servicioActivo, setServicioActivo] = useState(null);

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  const API = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  /* 📱 Detectar mobile */
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  /* 📅 Cargar servicios asignados */
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/cronograma/my_services`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setServicioActivo(user?.servicioActivo || null);

        const data = res.data.map((s) => ({
          id: s._id,
          title: s.tipo,
          start: s.fechaProgramada,
          backgroundColor: estadoColors[s.estado] || "#9ca3af",
          borderColor: estadoColors[s.estado] || "#9ca3af",
          extendedProps: {
            estado: s.estado,
            cliente: s.equipo?.cliente?.name,
            equipo: `${s.equipo?.marca?.name || ""} ${
              s.equipo?.modelo?.name || ""
            }`,
            observaciones: s.observaciones,
            tipo: s.tipo,
          },
        }));

        setEventos(data);
      } catch (e) {
        toast.error("Error cargando agenda");
      }
    };

    fetch();
    // eslint-disable-next-line
  }, [API, token]);

  /* ▶️ Iniciar servicio */
  const iniciarServicio = async () => {
    navigate(`/manage/${eventoActivo.id}`);
  };

  return (
    <>
      <Card>
        <CardContent className="p-0">
          <h2 className="text-lg font-semibold p-4">
            🗓️ Mi agenda de servicios
          </h2>

          <FullCalendar
            plugins={[dayGridPlugin, listPlugin, interactionPlugin]}
            locale={esLocale}
            events={eventos}
            initialView={isMobile ? "listDay" : "dayGridMonth"}
            headerToolbar={{
              left: "prev,next",
              center: "title",
              right: isMobile ? "listDay" : "dayGridMonth,listWeek",
            }}
            eventClick={(info) => setEventoActivo(info.event)}
            dayMaxEventRows={isMobile ? 1 : 3}
            eventContent={(arg) => (
              <div className="text-xs leading-tight overflow-hidden">
                <div className="font-semibold truncate">{arg.event.title}</div>
                <div className="truncate opacity-80">
                  {arg.event.extendedProps.equipo}
                </div>
              </div>
            )}
          />
        </CardContent>
      </Card>

      {/* 🔍 MODAL */}
      <Dialog
        open={!!eventoActivo}
        onClose={() => setEventoActivo(null)}
        className="fixed inset-0 z-[9999]"
      >
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black/50" aria-hidden="true" />

        {/* Contenedor */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="bg-white rounded-xl max-w-md w-full p-5 shadow-2xl">
            <div className="flex justify-between items-center mb-3">
              <Dialog.Title className="text-lg font-bold">
                {eventoActivo?.title}
              </Dialog.Title>
              <button onClick={() => setEventoActivo(null)}>
                <X />
              </button>
            </div>

            {/* contenido */}
            <div className="space-y-2 text-sm mb-4">
              <p>📅 {new Date(eventoActivo?.start).toLocaleString()}</p>
              <p>🏢 {eventoActivo?.extendedProps.cliente}</p>
              <p>🛠 {eventoActivo?.extendedProps.equipo}</p>
              <p>📌 Estado: {eventoActivo?.extendedProps.estado}</p>
              <p className="text-gray-600">
                🧾 {eventoActivo?.extendedProps.observaciones || "Sin notas"}
              </p>
            </div>

            <button
              onClick={iniciarServicio}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg"
            >
              Iniciar servicio
            </button>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
